<template>
  <div>
    <div
      class="container"
      v-bind:class="{ vertical }"
      v-if="vista && vista.config.paso"
    >
      <arrow-left />
      <div class="adelante">
        <sales-button
          class="button"
          :label="nombreSiguiente"
          :disabled="disabled === true"
          @click="adelante"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SalesButton from "@/components/core/SalesButton";
import ArrowLeft from "@/components/core/ArrowLeft";
export default {
  name: "StepNavigator",
  components: { SalesButton, ArrowLeft },
  props: {
    value: Object,
    storeAction: String,
    disabled: Boolean,
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vista: null
    };
  },
  methods: {
    adelante() {
      this.$store.dispatch(this.storeAction, this.value);
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
  },
  computed: {
    nombreSiguiente() {
      return this.vista.config.nombreSiguiente || "Continuar";
    }
  }
};
</script>

<style scoped>
div.container {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  height: 56px;
}

p {
  margin-left: 16px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #237aba;
}

div.adelante .button {
  height: auto;
  padding: 0;
  margin: 0;
}

/* Para dar vuelta los botones */
div.container.vertical {
  flex-direction: column-reverse;
  /* Fix botón que desaparece */
  padding-bottom: 0;
  height: auto;
  min-height: 1px;
}

div.container.vertical .button {
  margin-bottom: 40px;
}
</style>
